// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a805dac2","732":"d7d8b86e","977":"6141ff08"}[chunkId] + ".chunk.js";
};